import {createActions} from 'redux-arc';

export const {types, creators: userCreators} = createActions('users', {
  setDarkMode: null
});
